import CalculationForm from './form/Form.vue';

const defItem = {
  id: 0,
  product: {
    name: '',
    show_price: 1,
  },
  quantity: 0,
  price: 0,
  cost: 0,
};

export default {
  name: 'CalculationTable',

  components: {
    CalculationForm,
  },

  data() {
    return {
      // v-model для формы
      valid: false,
      dialog: false,
      dialogUpdate: false,
      positionModal01: false,
      showActionsMobile: false,
      overlay: false,
      formItems: [Object.assign({}, defItem)],
      itemEdit: Object.assign({}, defItem),
      submitIsProcessing: false,
      // Правила валидации формы
      rules: {
        requiredNumber: value => value > 0 || 'Поле должно быть заполнено',
      },
    };
  },
  watch: {
    'itemEdit.quantity': 'updateEditItem',
    'itemEdit.product.price': 'updateEditItem',
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    projecting() {
      return this.$store.state.design.projecting;
    },
    account() {
      return this.$store.state.design.account;
    },
    items() {
      return this.$store.state.design.account?.positions;
    },
  },
  methods: {
    numberFormat(num) {
      return (new Intl.NumberFormat('ru').format(num));
    },
    updateEditItem() {
      this.itemEdit.cost = this.itemEdit.product.price * this.itemEdit.quantity;
    },
    savePositions() {
      let max = 1;
      this.items.forEach((value) => {
        if (max < value.id) {
          max = value.id;
        }
      });
      this.formItems.forEach((value) => {
        max += 1;
        value.id = max;
        // eslint-disable-next-line
        value.price = parseInt(value.price);
        // eslint-disable-next-line
        value.quantity = parseInt(value.quantity);
        if (typeof value.product === 'string') {
          value.product = {
            name: value.product,
            article: '',
            id: 0,
            price: value.price,
            show_price: 1,
          };
        }
        value.cost = value.price * value.quantity;
        this.items.push(value);
      });
      this.resetForm();
      this.dialog = false;
    },
    addItem() {
      // Добавляем новый пустой элемент
      this.formItems.push(Object.assign({}, defItem));
    },
    updateItem(values) {
      this.formItems[values.index].price = values.value.price ?? 0;
      this.formItems[values.index].show_price = values.value.show_price ?? 1;
      // eslint-disable-next-line
      this.formItems[values.index].cost = this.formItems[values.index].price * this.formItems[values.index].quantity;
    },
    removeItem(index) {
      // Удаляем элемент по индексу
      this.formItems.splice(index, 1);
    },
    removeMainItem(id) {
      // eslint-disable-next-line
      this.$store.state.design.account.positions = this.$store.state.design.account.positions.filter(item => item.id !== id);
    },
    updateMainItem(item) {
      this.itemEdit = item;
      this.dialogUpdate = true;
    },
    // Метод для получения всех данных формы
    getFormData() {
      return this.formItems;
    },
    // Метод для сброса формы
    resetForm() {
      this.formItems = [Object.assign({}, defItem)];
    },
    toggleActionsMobile() {
      this.showActionsMobile = !this.showActionsMobile;
      this.overlay = !this.overlay;
      const htmlElement = document.documentElement;
      if (this.showActionsMobile) {
        htmlElement.classList.add('overflow-y-hidden');
      } else {
        htmlElement.classList.remove('overflow-y-hidden');
      }
    },
    updateTotalCost() {
      const app = this;
      const account = {
        ...app.account,
        profile_id: app.user.profile_id,
      };

      const restURL = 'design/api/account/update-total-cost';

      app.$store.getters.axl
        .post(restURL, account)
        .then(() => {
          app.$store.dispatch('design/AccountGetView', {
            profile_id: app.user.profile_id,
            application_id: app.projecting.id,
          });
          app.$store.dispatch('ShowInfo', 'Смета отправлена на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    saveAccount() {
      this.submitIsProcessing = true;
      const app = this;
      let restURL = 'design/api/account/create';

      if (app.account.id) {
        restURL = 'design/api/account/update';
      }

      const account = {
        ...app.account,
        profile_id: app.user.profile_id,
      };

      app.$store.getters.axl
        .post(restURL, account)
        .then(() => {
          app.$store.dispatch('design/AccountGetView', {
            profile_id: app.user.profile_id,
            application_id: app.projecting.id,
          });
          app.$store.dispatch('ShowInfo', 'Смета отправлена на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        }).finally(() => {
          app.submitIsProcessing = false;
        });
    },
    /**
     * Скачать
     */
    openUrl() {
      window.open(this.account.url, '_blank');
    },
  },
  mounted() {
    this.$store.dispatch('design/AccountGetView', {
      profile_id: this.user.profile_id,
      application_id: this.projecting.id,
    });
  },
};
